import React from 'react'
import Link from 'gatsby-link'

import styles from './Popup.module.css'
import FieldDefinitions from '../data/FieldDefinitions'

export default ({ edge, step, zusatzInfo, intToTime }) => (
  <div key={step}>
    <span className="bold">{edge.node.Bezeichnung}</span>
    <br />
    <table className={styles.facilities}>
      <tbody>
        <tr>
          <td />
          <td>
            <div className={styles.longtext}>Öffnungszeiten</div>
            <div className={styles.shorttext}>Offen</div>
          </td>
          <td>
            <div className={styles.longtext}>Schließtage im Jahr</div>
            <div className={styles.shorttext}>Zu im Jahr</div>
          </td>
        </tr>
        <tr>
          <td>{edge.node.Adresse}</td>
          <td>
            <table className={styles.betriebe}>
              <tbody>
                <tr>
                  <td>Mo</td>
                  <td>
                    {intToTime(edge.node.Movon1)} –{' '}
                    {intToTime(edge.node.Mobis1)}
                    {edge.node.Movon2
                      ? `\u2001${intToTime(edge.node.Movon2)} – ${intToTime(
                          edge.node.Mobis2
                        )}`
                      : ''}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td>
            <table className={styles.closed}>
              <tbody>
                <tr>
                  <td>
                    <div className={styles.longtext}>Sommerferien</div>
                    <div className={styles.shorttext}>Som.</div>
                  </td>
                  <td>{edge.node.Sommer}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td>{edge.node.PLZ + ' ' + edge.node.Ort}</td>
          <td>
            <table className={styles.betriebe}>
              <tbody>
                <tr>
                  <td>Di</td>
                  <td>
                    {intToTime(edge.node.Divon1)} –{' '}
                    {intToTime(edge.node.Dibis1)}
                    {edge.node.Divon2
                      ? `\u2001${intToTime(edge.node.Divon2)} – ${intToTime(
                          edge.node.Dibis2
                        )}`
                      : ''}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td>
            <table className={styles.closed}>
              <tbody>
                <tr>
                  <td>
                    <div className={styles.longtext}>Weihnachten</div>
                    <div className={styles.shorttext}>Wei.</div>
                  </td>
                  <td>{edge.node.Weihnacht}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            {zusatzInfo && (
              <span>
                Telefonnummer:{' '}
                <a href={'tel:' + zusatzInfo.Telefon_Einrichtung}>
                  {zusatzInfo.Telefon_Einrichtung}
                </a>
              </span>
            )}
          </td>
          <td>
            <table className={styles.betriebe}>
              <tbody>
                <tr>
                  <td>Mi</td>
                  <td>
                    {intToTime(edge.node.Mivon1)} –{' '}
                    {intToTime(edge.node.Mibis1)}
                    {edge.node.Mivon2
                      ? `\u2001${intToTime(edge.node.Mivon2)} – ${intToTime(
                          edge.node.Mibis2
                        )}`
                      : ''}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td>
            <table className={styles.closed}>
              <tbody>
                <tr>
                  <td>
                    <div className={styles.longtext}>Semesterferien</div>
                    <div className={styles.shorttext}>Sem.</div>
                  </td>
                  <td>{edge.node.Semester}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td />
          <td>
            <table className={styles.betriebe}>
              <tbody>
                <tr>
                  <td>Do</td>
                  <td>
                    {intToTime(edge.node.Dovon1)} –{' '}
                    {intToTime(edge.node.Dobis1)}
                    {edge.node.Dovon2
                      ? `\u2001${intToTime(edge.node.Dovon2)} – ${intToTime(
                          edge.node.Dobis2
                        )}`
                      : ''}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td>
            <table className={styles.closed}>
              <tbody>
                <tr>
                  <td>
                    <div className={styles.longtext}>Ostern</div>
                    <div className={styles.shorttext}>Ost.</div>
                  </td>
                  <td>{edge.node.Ostern}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td />
          <td>
            <table className={styles.betriebe}>
              <tbody>
                <tr>
                  <td>Fr</td>
                  <td>
                    {intToTime(edge.node.Frvon1)} –{' '}
                    {intToTime(edge.node.Frbis1)}
                    {edge.node.Frvon2
                      ? `\u2001${intToTime(edge.node.Frvon2)} – ${intToTime(
                          edge.node.Frbis2
                        )}`
                      : ''}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td>
            <table className={styles.closed}>
              <tbody>
                <tr>
                  <td>
                    <div className={styles.longtext}>sonstige</div>
                    <div className={styles.shorttext}>son.</div>
                  </td>
                  <td>{edge.node.sonstzu}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    Mittagessenangebot: {edge.node.Essen === 1 ? 'ja' : 'nein'}
    <br />
    <hr />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Betreuung.js